import { PaginatedVacationDaysQueryVariables } from "@/graphql/__generated__/graphql";
import ValueRangeFilter from "../../Shared/ValueRangeFilter";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedVacationDaysQueryVariables) => void;
}

/**
 * VacationDaysValueRange component for filtering vacation days by value ranges
 * Handles both days and lengthOfEmployment value range filters
 * @param props Component properties
 * @returns JSX element
 */
function VacationDaysValueRange({ displayAmount, handleSubmitClick }: Props) {
  const vacationDaysValueConfig = {
    paginationStateKey: "paginatedVacationDays" as keyof PaginationState,
    fields: [
      {
        fieldName: "days",
        labelKey: "components:filters.vacationdays.sortfields.days",
        inputStyle: "integer" as const,
        useBasisPoints: false,
        decimalScale: 0,
        placeholder: "0"
      },
      {
        fieldName: "lengthOfEmployment",
        labelKey: "components:filters.vacationdays.sortfields.lengthofemployment",
        inputStyle: "integer" as const,
        useBasisPoints: false,
        decimalScale: 0,
        placeholder: "0"
      }
    ],
    defaultButtonTextKey: "components:filters.vacationdays.value",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      valueRanges: Record<string, { gte: number | null; lte: number | null }>,
      sort?: any
    ): PaginatedVacationDaysQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: filters.activeFrom || null,
        days: valueRanges.days,
        lengthOfEmployment: valueRanges.lengthOfEmployment,
        provinces: filters.provinces || null,
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      days: paginationState.filters?.days,
      lengthOfEmployment: paginationState.filters?.lengthOfEmployment,
      provinces: paginationState.filters?.provinces,
    })
  };

  return (
    <ValueRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={vacationDaysValueConfig}
    />
  );
}

export default VacationDaysValueRange;
